<template><ArticlePage page="blog-vs-wa" :content="content" /></template>
<script>
import ArticlePage from '@/components/ArticlePage.vue';
import content from '@/documents/content/blog-vs-wa.js';
export default { name: 'BlogVsWa', components: { ArticlePage }, data: () => ({ content }) };
</script>
